import { useState, useCallback } from 'react';
import { INITIAL_FORM_STATE, INITIAL_FILES_STATE, INITIAL_FORM_ERRORS } from '../config';
import formValidation from '../formValidation';

export const useConstitutionForm = (createConstitution, updateConstitution, handleCloseModal) => {
    const [form, setForm] = useState(INITIAL_FORM_STATE);
    const [files, setFiles] = useState(INITIAL_FILES_STATE);
    const [errors, setErrors] = useState(INITIAL_FORM_ERRORS);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const handleInputChange = useCallback((name, value) => {
        setForm((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: '' }));
    }, []);

    const handleFileChange = useCallback((name, value) => {
        setFiles((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: '' }));
    }, []);

    const resetForm = useCallback(() => {
        setForm(INITIAL_FORM_STATE);
        setFiles(INITIAL_FILES_STATE);
        setErrors(INITIAL_FORM_ERRORS);
        setIsEdit(false);
        setSelectedItem(null);
    }, []);

    const setEditData = useCallback((item) => {
        setIsEdit(true);
        setSelectedItem(item);
        
        // Format the date for the HTML date input (YYYY-MM-DD)
        const formatDateForInput = (dateString) => {
            if (!dateString) return '';
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return '';
            return date.toISOString().split('T')[0];
        };
        
        setForm({
            title: item?.title,
            description: item?.description,
            date: formatDateForInput(item?.date),
        });
        setErrors(INITIAL_FORM_ERRORS);
        setFiles(INITIAL_FILES_STATE);
        // Note: Form data will be set by the modal component
    }, []);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        const isValid = formValidation(form, isEdit, files, setErrors);
        if (!isValid) {
            return;
        }

        const formData = new FormData();
        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });
        
        if (files.manual) {
            formData.append('manual', files.manual);
        }
        if (files.thumbnail) {
            formData.append('thumbnail', files.thumbnail);
        }
        
        if (isEdit) {
            formData.append('id', selectedItem?.id);
            updateConstitution(formData, {
                onSuccess: () => {
                    handleCloseModal();
                }
            });
        } else {
            createConstitution(formData, {
                onSuccess: () => {
                    handleCloseModal();
                }
            });
        }
        
    }, [form, files, isEdit, selectedItem, updateConstitution, createConstitution, handleCloseModal]);

    return {
        form,
        files,
        errors,
        isEdit,
        selectedItem,
        handleInputChange,
        handleFileChange,
        resetForm,
        setEditData,
        handleSubmit
    };
}; 